import storage from "@/utils/storage"
function getHeight() {
    return window.innerHeight - 46;
}
function formatDateTime(datatime, type) {
    let replaceTime;
    if (datatime) {
        var patt1 = new RegExp("-");
        var result = patt1.test(datatime);
        if (result) {
            replaceTime = datatime.replace(/-/g, '/')
        } else {
            replaceTime = datatime
        }

    } else {
        replaceTime = new Date()
    }
    var date = new Date(replaceTime);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? "0" + m : m;
    var d = date.getDate();
    d = d < 10 ? "0" + d : d;
    var h = date.getHours();
    h = h < 10 ? "0" + h : h;
    var minute = date.getMinutes();
    // var second = date.getSeconds();
    minute = minute < 10 ? "0" + minute : minute;
    // second = second < 10 ? "0" + second : second;
    if (new Date().getFullYear() == y && type == 'comment') {
        return m + "-" + d + " " + h + ":" + minute;
    } else if (type == 'month') {
        return y + "-" + m + "-" + d;
    } else {
        return y + "-" + m + "-" + d + " " + h + ":" + minute;
    }
}
function getUserAgent() {
    const u = navigator.userAgent;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端

    if (isAndroid) {

        let str = window.WebContainer.UserAgent;
        console.log('window.WebContainer:', window.WebContainer)
        console.log('window.WebContainer.UserAgent:', str)
        if (str == 'OneOffice') {
            return true;
        } else {
            return false;
        }
    } else {
        return true;
    }
}
//base64转码（压缩完成后的图片为base64编码，这个方法可以将base64编码转回file文件）
function dataURLtoFile(dataurl, file) {
    var arr = dataurl.split(','),
        // mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    console.log(new File([u8arr], file.name, { type: file.type }))
    return new File([u8arr], file.name, { type: file.type });
}
//压缩图片
function compressImg(file) {
    // var src;
    var files;
    var fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2);
    var read = new FileReader();
    read.readAsDataURL(file);
    return new Promise(function (resolve) {
        read.onload = function (e) {
            var img = new Image();
            img.src = e.target.result;
            img.onload = function () {
                //默认按比例压缩
                var w = this.width,
                    h = this.height;
                //生成canvas
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                var base64;
                // 创建属性节点
                canvas.setAttribute("width", w);
                canvas.setAttribute("height", h);
                ctx.drawImage(this, 0, 0, w, h);
                if (fileSize < 1) {
                    //如果图片小于3M 那么不执行压缩操作
                    base64 = canvas.toDataURL(file['type'], 1);
                } 
                else if (fileSize >= 1 && fileSize <= 7) {
                    base64 = canvas.toDataURL(file['type'], 1 - (fileSize / 10));
                }
                 else {
                    //直接全部缩小
                    console.log(fileSize)
                    base64 = canvas.toDataURL(file['type'], 0.1);
                }
                // 回调函数返回file的值（将base64编码转成file）
                files = dataURLtoFile(base64, file);
                resolve(files)
            };
        };
    })
}
function goNative() {
    const u = navigator.userAgent;
    // const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    console.log(isiOS);
    storage.remove("effectiveToken");
    storage.remove("effective_userId");
    storage.remove("moaToken");
    if (isiOS) {
      window.webkit.messageHandlers.backToList.postMessage(null);
    } else {
      window.WebContainer.backToList();
    }
  }

export default {
    getHeight,
    formatDateTime,
    getUserAgent,
    compressImg,
    goNative
}